{
  "name": "front",
  "version": "5.6.0",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve --host 0.0.0.0 --port 4200 --configuration=development --poll=500",
    "build": "ng build",
    "build:production": "ng build --configuration=production",
    "build:preprod": "ng build --configuration=preprod",
    "watch": "ng build --watch --configuration=development",
    "test": "ng test",
    "test:headless": "ng test --no-progress --browsers=ChromeHeadless",
    "test:ci": "ng test --project=front --watch=false --no-progress --browsers=ChromeHeadless"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@angular/service-worker": "^22.2.4",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-regular-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@ngrx/signals": "^22.0.0",
    "@ngrx/store": "^22.0.0",
    "@taiga-ui/addon-commerce": "^5.30.0",
    "@taiga-ui/addon-doc": "^5.30.0",
    "@taiga-ui/addon-mobile": "^5.30.0",
    "@taiga-ui/addon-table": "^5.30.0",
    "@taiga-ui/cdk": "^5.30.0",
    "@taiga-ui/core": "^5.30.0",
    "@taiga-ui/event-plugins": "^5.1.0",
    "@taiga-ui/icons": "^5.30.0",
    "@taiga-ui/kit": "^5.30.0",
    "@taiga-ui/layout": "^5.30.0",
    "@types/pako": "^2.0.4",
    "apexcharts": "^6.7.0",
    "appwrite": "^24.1.1",
    "buffer": "^6.0.3",
    "dompurify": "^3.3.3",
    "eslint": "^10.2.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "file-saver": "^2.0.5",
    "hammerjs": "^2.0.8",
    "heic-to": "^1.6.6",
    "keen-slider": "^6.8.6",
    "ng-apexcharts": "3.1.0",
    "ng-qrcode": "^22.0.0",
    "ngx-editor": "^19.1.1",
    "ngx-image-cropper": "^9.1.6",
    "ngx-owl-carousel-o": "^22.0.0",
    "pako": "^2.1.0",
    "pdfmake": "^0.3.7",
    "prettier": "^3.9.10",
    "rxjs": "~7.8.2",
    "signature_pad": "^5.1.3",
    "socket.io-client": "^4.8.3",
    "tslib": "^2.8.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@types/file-saver": "^2.0.7",
    "@types/html-to-pdfmake": "^2.4.5",
    "@types/jasmine": "~6.0.0",
    "@types/node": "^25.5.2",
    "@types/pdfmake": "^0.3.2",
    "jasmine-core": "~6.1.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "typescript": "~6.0.3"
  }
}
